/**
 * Which build this is — the one fact the Update sheet always has something to say about.
 *
 * Frozen into the bundle by `vite.config.ts`'s `define`, from git rather than from a deploy
 * variable, so it cannot disagree with the code it ships beside.
 */

declare const __SELOGATE_BUILD__: { commit: string; builtAt: string } | undefined
declare const __SELOGATE_STORE_BUILD__: number | undefined

export interface BuildIdentity {
  /** Short commit SHA, or `unknown` where git was unavailable at build time. */
  readonly commit: string
  /** ISO instant the bundle was built, or `undefined` in a context with no build (tests, dev). */
  readonly builtAt: string | undefined
  /**
   * **`store-build.json`'s monotonic counter (D261), and `undefined` means *no store* (R9 §4.4,
   * D330).**
   *
   * Set only by `native/scripts/release.mjs`, through `vite.config.ts`'s `storeBuildDefine()`.
   * A PWA bundle and a sideloaded debug build both carry `undefined`, **and the build floor does
   * not apply to either** — a browser client is never more than one deploy behind, D137's update
   * prompt being its rail, and a sideload has no store to update from.
   *
   * It is a number rather than a version string on purpose: the floor is an integer comparison
   * and there is no semver comparator anywhere on this path (R9 §12).
   */
  readonly storeBuild: number | undefined
}

/**
 * `typeof` rather than a direct read: `vitest.config.ts` is a separate config with no `define`,
 * so the identifier is genuinely absent there and a bare reference throws `ReferenceError` on
 * import — taking down every test that renders the sheet, in a way that looks nothing like its
 * cause.
 *
 * **`__SELOGATE_STORE_BUILD__` takes the same posture for a second reason on top of that one**:
 * its define is *absent by design* in every web build (R9 §4.4), so unlike `__SELOGATE_BUILD__`
 * the missing case is the common one rather than the test-only one.
 */
export const BUILD: BuildIdentity = {
  ...(typeof __SELOGATE_BUILD__ === 'undefined'
    ? { commit: 'dev', builtAt: undefined }
    : { commit: __SELOGATE_BUILD__.commit, builtAt: __SELOGATE_BUILD__.builtAt }),
  storeBuild: typeof __SELOGATE_STORE_BUILD__ === 'undefined' ? undefined : __SELOGATE_STORE_BUILD__,
}
